import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Serie } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteSerie, useSerie, useUpdateSerie } from '../../hooks/serie'
import SerieForm from '../../components/SerieForm'

export default function SerieEdit() {
  const { id } = useParams()
  const { data: serie } = useSerie(+id!)
  const deleteSerie = useDeleteSerie()
  const updateSerie = useUpdateSerie()
  const [modalRm, modalRmActions] = useModalTrigger<Serie>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/series">Serie</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {serie!.title.it}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(serie)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <SerieForm
          serie={serie}
          save={(formSerie) =>
            updateSerie.mutateAsync(formSerie).then(() =>
              toast.success('Serie salvata con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la serie {modalRm.value.title.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteSerie.isLoading}
            onClick={async () => {
              await deleteSerie.mutateAsync(modalRm.value!.id).then(() => {
                navigate('/series')
                modalRmActions.close()
              })
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
